export default "__VITE_ASSET__7YPOhzbR__"